module.exports = __webpack_public_path__ + "img/second-avater-1.d2ca3ea.png";